import { Component, OnInit } from '@angular/core';
import { CommonapiService } from '../../Service/Commonapi.service';
import { Common } from '../../Utility/Common';

@Component({
  selector: 'app-ProfileMenu',
  templateUrl: './ProfileMenu.component.html'
})
export class ProfileMenuComponent implements OnInit {

  constructor(private Winfoapi: CommonapiService) { }
  parent_det:any="";
  ngOnInit() {
    this.parent_det=Common.login_info;
    console.log("this.parent_det",this.parent_det)
  }
  Logout(){

    this.Winfoapi.Logout('locationdisabled');
    
  }
}
